import {
  FileText,
  Image,
  FileSpreadsheet,
  File,
  FileCode,
  FileVideo,
  FileAudio,
  FileArchive,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Maps a blob's claimed Content-Type to a lucide icon for the attachment row.
 * Best-effort and purely cosmetic — the icon never gates behaviour, so an
 * unknown type just falls back to the generic file glyph.
 */
export function iconForContentType(contentType: string | null): LucideIcon {
  if (!contentType) return File;
  if (contentType.startsWith('image/')) return Image;
  if (contentType.startsWith('video/')) return FileVideo;
  if (contentType.startsWith('audio/')) return FileAudio;
  if (contentType === 'application/pdf') return FileText;
  if (contentType.includes('spreadsheet') || contentType === 'text/csv') return FileSpreadsheet;
  if (contentType.includes('zip') || contentType.includes('compressed')) return FileArchive;
  if (contentType.includes('json') || contentType.includes('javascript') || contentType.includes('typescript')) return FileCode;
  return File;
}

/** Human-readable file size in 1024-byte units (e.g. "2.4 MB"). */
export function formatBytes(bytes: number | null): string {
  if (bytes == null) return '—';
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
}
